var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.4 27.7",
    style: {
      enableBackground: "new 0 0 22.4 27.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_2_",
    transform: "translate(109.231 757.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4_",
    className: "st0",
    d: "M-108.5-739.5c0,0,1.3-1.3,5.2-1.3c3.9,0,6.5,2.6,10.5,2.6s5.2-1.3,5.2-1.3v-15.7 c0,0-1.3,1.3-5.2,1.3c-3.9,0-6.5-2.6-10.5-2.6s-5.2,1.3-5.2,1.3V-739.5z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3_",
    className: "st0",
    x1: -108.5,
    y1: -730.3,
    x2: -108.5,
    y2: -739.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.62439e5219f867b55ddb4bfe70e31d9a.svg";
export { ForwardRef as ReactComponent };